// extracted by mini-css-extract-plugin
module.exports = {"root":"intro_root__Swbn8","doodles":"intro_doodles__15U8S","outer":"intro_outer__3G9Ya","inner":"intro_inner__3XGNB","heading":"intro_heading__36m1C"};